// Controls discovery of the advanced recovery UI, not funded escrow rules.
export const SHOW_OFFER_RECOVERY = process.env.NEXT_PUBLIC_OFFER_RECOVERY_UI === '1'
